import { ServiceResponse } from "../ServiceResponse";

export class UpdatePageStatusResponse extends ServiceResponse {
  public Updated: Date | null = null;
  public UpdatedText: string | null = null;
}
